export const SET_LINEUP_ORDER = 'SET_LINEUP_ORDER';

export const setLineupOrder = lineupOrder => ({type: SET_LINEUP_ORDER, value: {lineupOrder}});
